'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.MagicEmit = void 0;
var tslib_1 = require("tslib");
function hyphenate(str) {
    return str.replace(/\B([A-Z])/g, '-$1').toLowerCase();
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}
/**
 * Works the same as `Emit` with one exception - emits custom event
 * for non web components instead of vue emit
 * Requires decorated method first argument to be native event
 *
 * @param event Emitted event name
 * @param options Emit options
 * @param options.noStop Disable propagation stopping
 * @param options.noPrevent Disable default preventing
 * @see https://github.com/kaorun343/vue-property-decorator#Emit
 */
function MagicEmit(event, options) {
    if (options === void 0) { options = {}; }
    return function MagicEmitter(target, key, descriptor) {
        var eventName = event || hyphenate(key);
        var originalHandler = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!args[0] && !(args[0] instanceof Event)) {
                console.warn('[MagicEmit] First argument should be an event');
                return;
            }
            var originalEvent = args[0];
            var eventTarget = originalEvent.target;
            var isOwnEvent = this.$el === eventTarget &&
                originalEvent.detail;
            var shadowRoot = this.$root.$options.shadowRoot;
            // Whether the component is wrapped with web component wrapper or not
            var isLight = !shadowRoot || shadowRoot instanceof HTMLHeadElement;
            if (!options.noStop && !isOwnEvent) {
                originalEvent.stopPropagation();
            }
            if (!options.noPrevent && !isOwnEvent) {
                originalEvent.preventDefault();
            }
            var emit = function (returnVal) {
                if (returnVal !== undefined) {
                    args.unshift(returnVal);
                }
                if (isLight) {
                    if (isOwnEvent) {
                        return;
                    }
                    var customEvent = new CustomEvent(eventName, {
                        bubbles: true,
                        cancelable: true,
                        composed: true,
                        detail: tslib_1.__spreadArray([], args),
                    });
                    _this.$el.dispatchEvent(customEvent);
                }
                else {
                    _this.$emit.apply(_this, tslib_1.__spreadArray([eventName], args));
                }
            };
            var returnValue = originalHandler.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(function (promiseValue) {
                    emit(promiseValue);
                });
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
exports.MagicEmit = MagicEmit;
